module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY0MCA4OTZhMzIgMzIgMCAwIDEgMCA2NGgtMjU2YTMyIDMyIDAgMCAxIDAtNjRoMjU2eiBtMTYwLTc2OGE2NCA2NCAwIDAgMSA2NCA2NHYxMDguNmE2NCA2NCAwIDAgMS0xMC44IDM1LjVMNjcyIDYwOHYxNjBhNjQgNjQgMCAwIDEtNjQgNjRoLTE5MmE2NCA2NCAwIDAgMS02NC02NHYtMTYwbC0xODEuMi0yNzEuOUE2NCA2NCAwIDAgMSAxNjAgMzAwLjZWMTkyYTY0IDY0IDAgMCAxIDY0LTY0aDU3NnogbTAgNjRIMjI0djEwOC42bDE5MiAyODhWNzY4aDE5MnYtMTc5LjRsMTkyLTI4OFYxOTJ6IiBmaWxsPSIjMCIgcC1pZD0iMTE0OCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Filter-outlined.svg
// module id = cX53
// module chunks = 73